/**
 * 校验回跳地址是否为合法的站内路径。
 * 拒绝外部 URL（http://...）、协议相对路径（//...）以及非 / 开头的目标。
 *
 * 未匹配到具体路由的情况由路由表的 catch-all（* → /404）兜底，
 * 此处不再重复做 matchRoutes 校验，避免与 app 层产生循环依赖。
 */
export function isInternalPath(path: string | null | undefined): path is string {
  if (!path) return false
  if (!path.startsWith('/')) return false
  if (path.startsWith('//')) return false
  return true
}

export function resolveSafeRedirect(target: string | null | undefined): string {
  return isInternalPath(target) ? target : '/'
}
